import React from 'react'

const Mission = () => {
  return (
    <div>Mission Statement</div>
  )
}

export default Mission